import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Student {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  status: string;
  class: {
    id: string;
    name: string;
  } | null;
}

interface StudentState {
  students: Student[];
  selectedStudentId: string | null;
}

const initialState: StudentState = {
  students: [],
  selectedStudentId: null,
};

const studentSlice = createSlice({
  name: "student",
  initialState,
  reducers: {
    setStudents: (state, action: PayloadAction<Student[]>) => {
      state.students = action.payload;
    },
    setSelectedStudentId: (state, action: PayloadAction<string>) => {
      state.selectedStudentId = action.payload;
    },
    clearStudentData: () => initialState,
  },
});

export const { setStudents, setSelectedStudentId, clearStudentData } = studentSlice.actions;
export default studentSlice.reducer;
